import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { FormField, Input } from '@wix/design-system';
import { useAppStore } from 'stores/appStore';

export const SelectNameStepInput: FC = () => {
  const { t } = useTranslation();

  const storeName = useAppStore((state) => state.storeName);
  const setStoreName = useAppStore((state) => state.setStoreName);

  return (
    <FormField>
      <Input
        placeholder={t('select-name-step.input.placeholder')}
        onChange={(e) => setStoreName(e.target.value)}
        value={storeName}
      />
    </FormField>
  );
};
